import React, { useEffect, useState } from 'react';
import { Page, Swiper, Toast } from 'react-weui';
import JsBarcode from 'jsbarcode';
import QRcode from 'qrcode.react';

import { queryCardList } from '@/services/myself';

const ElecCard = (props) => {

  const { currentCode, index } = props;

  // const [currentCode, setCurrentCode] = useState('SFSARE2SFDS2344');

  useEffect(() => {

    if (currentCode) {
      JsBarcode("#barCode" + index, currentCode, {
        font: "OCR-B",
        text: currentCode.substring(0, 3) + '******' + currentCode.substring(currentCode.length - 3),
      });
    }

  }, [currentCode]);

  return (
    <div style={{paddingTop: '10px'}}>

      <div style={{width: '100%', textAlign: 'center', backgroundColor: '#FFFFFF'}}>
        <svg style={{width: '100%', height: '50px', marginTop: '10px'}} id={`barCode${index}`}>
        </svg>
      </div>

      <div style={{textAlign: 'center', marginTop: '20px', width: '100%'}}>
        <QRcode
          size={256}
          level={'H'}
          style={{marginRight: 'auto', marginLeft: 'auto'}}
          value={currentCode} />
      </div>

    </div>
  )
}

export default (props) => {

  const [cardList, setCardList] = useState([]);
  const [isRequest, setIsRequest] = useState(false);

  useEffect(() => {
    setIsRequest(true);
    queryCardList({}).then(res => {
      if (res && res.code === 200) {
        setCardList(res.data);
      }
    }).finally(() => setIsRequest(false));
  }, []);

  return (
    <>
      {
        cardList.length > 0 ? <Swiper height={"600"}>
        {
          cardList.map((item, index) => (
            <div>
            <ElecCard currentCode={item.elecNumber} index={index} key={item.id} />
            </div>
          ))
        }
      </Swiper> : (
        <div style={{textAlign: 'center', color: '#999999', paddingTop: '30px', fontSize: '15px' }}>暂无电子卡</div>
        )}

      <Toast icon="loading" show={isRequest}>加载中...</Toast>
    </>
  )
}
